const getApartments = (t) => ({
  studioAp: t('constants.apartments.studioAp'),
  oneAp: t('constants.apartments.oneAp'),
  twoAp: t('constants.apartments.twoAp'),
  threeAp: t('constants.apartments.threeAp'),
  allAp: t('constants.apartments.allAp'),
  penthaus: t('constants.apartments.penthaus'),
});

export default getApartments;



// WEBPACK FOOTER //
// ./src/constants/apartments.js